import { render, staticRenderFns } from "./BrandCircle.vue?vue&type=template&id=34f87a35&"
import script from "./BrandCircle.vue?vue&type=script&lang=js&"
export * from "./BrandCircle.vue?vue&type=script&lang=js&"
import style0 from "./BrandCircle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports